import AltInstance from '../../../Common/Globals/Scripts/AltInstance';
import RecoverAccountApi from '../Apis/RecoverAccountApi';
import ActionHelper from '../../../Common/Actions/ActionHelper';
import NotificationActions from '../../../Common/Actions/NotificationActions';
import ErrorHandler from "../../../Common/Utilities/ErrorHandler.js";
import FieldLimits from "../../../Common/Metadata/FieldLimits.js";

class RecoverAccountActions {
    async sendAccountRecoveryEmail(userName) {
        if(!userName || userName.length === 0 || userName.length > FieldLimits.resource.email.length) {
            ErrorHandler.displayError([`'Login' cannot be blank and must not contain more than ${FieldLimits.resource.email.length} characters. Please ensure the request is valid and re-submit it.`]);
            return;
        }

        try {
            await ActionHelper.executeRequest(() => RecoverAccountApi.sendAccountRecoveryEmail(userName));
        }
        catch(error) {
            throw error;
        }

        NotificationActions.notificationReceived({
            icon: 'check',
            severity: 'success',
            title: 'An email has been sent',
            messages: ['If your username is correct, a password reset email has been sent. If you do not receive this email, please contact eCargo support.']
        });
    }
}

export default AltInstance.createActions(RecoverAccountActions);
